import React, { createContext, useCallback, useContext, useState } from "react"

const messageSenderContext = createContext<string>("")

const messageSenderUpdateContext = createContext<Function>(() => {})

interface Props {
  children: React.ReactNode
}

function MessageSenderProvider({ children }: Props) {
  const [message, setMessage] = useState<string>("")

  return (
    <messageSenderContext.Provider value={message}>
      <messageSenderUpdateContext.Provider value={setMessage}>
        {children}
      </messageSenderUpdateContext.Provider>
    </messageSenderContext.Provider>
  )
}

function useMessageSender() {
  const message = useContext(messageSenderContext)

  return message
}

function useMessageSenderUpdater() {
  const setMessage = useContext(messageSenderUpdateContext)

  const handleMessage = useCallback(
    (message: string) => setMessage(message),
    [setMessage],
  )

  const appendMessage = useCallback(
    (message: string) =>
      setMessage((prevMessage: string) => prevMessage + message),
    [setMessage],
  )

  return { handleMessage, appendMessage }
}

export {
  MessageSenderProvider,
  messageSenderContext,
  messageSenderUpdateContext,
  useMessageSender,
  useMessageSenderUpdater,
}
